<template>
    <div class="online-status">
        <div :class="'indicator remote '+( this.state.remote ? 'connected' : 'offline' )">
            inet
        </div>
        <div :class="'indicator local '+( this.state.local ? 'connected' : 'offline' )">
            wifi
        </div>
    </div>
</template>
<script>
export default {

    name: "OnlineStatus",
    data()
    {
        return {
            state: {}
        }
    },
    created()
    {
        this.sockets = this.$core.getWebsockets()
        if( this.sockets )
        {
            this.state = this.sockets.state
        }

    }
}
</script>